import { createModal } from '/@/core/elements/modal'

export interface PaperformData {
  title: string
  paperformId: string | null
}

const { api, component } = createModal<PaperformData>(
  'PaperformModal',
  () => import('./PaperformModal.vue'),
  {
    title: 'Short survey',
    paperformId: null,
  },
)

export const usePaperformModal = api
export default component
